/* eslint-disable import/prefer-default-export */
export enum ProductAvailability {
    Immediate = 'IMMEDIATE',
}
